import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider as MUIThemeProvider } from '@mui/material/styles';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { ThemeProvider as EmotionThemeProvider } from '@emotion/react';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider as CustomThemeProvider } from './context/ThemeContext';
import App from './App';
import './index.css';

// Create a root element
const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <CustomThemeProvider>
        <MUIThemeProvider theme={{}}>
          <StyledThemeProvider theme={{}}>
            <EmotionThemeProvider theme={{}}>
              <CssBaseline />
              <App />
            </EmotionThemeProvider>
          </StyledThemeProvider>
        </MUIThemeProvider>
      </CustomThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);